import { Validation, ValueObject } from '@singularsystems/neo-core';

export default class InternalApproverPagedCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public firstName: string = "";

    public lastName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Criteria";
    }
}